import { Box, Grid2, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { exchangeData } from "../../../assets/data/data";
import ContentCard from "../../../components/Content/ContentCard";
import { useSelector } from "react-redux";
import { ErrorSnackbar } from "../../../components/Common/CustomSnackbar";

const MainComp = ({ setModalState, setSessionComp, setFilterResults }) => {
  const theme = useTheme();

  const [error, setError] = useState(false);
  const { userData } = useSelector((state) => state.user);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ErrorSnackbar
        error={error}
        handleCloseError={setError}
        errorMsg={"You need to be a student or graduate to access this."}
      />
      <Typography
        sx={{
          fontFamily: "'Quicksand', sans-serif",
          fontWeight: "bold",
          fontSize: "18px",
          color: theme.palette.text.primary,
          mt: 3,
        }}
      >
        Key features:
      </Typography>

      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        {exchangeData.map((item, index) => (
          <React.Fragment key={item.id}>
            <ContentCard
              item={item}
              height={"250px"}
              clickable={item.modal || item.page}
              onClick={() => {
                if (item.modal) {
                  const allowedRoles = ["student", "graduate"];
                  if (allowedRoles.includes(userData?.role)) {
                    setModalState(true);
                  } else {
                    setError(true);
                  }
                }
                if (item.page) {
                  setSessionComp("setupsession");
                }
                if (item.filter) {
                  setFilterResults(true);
                } else {
                  setFilterResults(false);
                }
              }}
            />

            {index === 2 && (
              <Grid2 item size={{ xs: 12 }}>
                <Typography
                  sx={{
                    fontFamily: "'Quicksand', sans-serif",
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: theme.palette.text.primary,
                  }}
                >
                  How to Get Started
                </Typography>
              </Grid2>
            )}
          </React.Fragment>
        ))}
      </Grid2>

      <Typography sx={[theme.body, { mt: 3 }]}>
        Take advantage of this "heal the healer" model to enhance your
        hypnotherapy practice while receiving valuable support from your peers.
      </Typography>
    </Box>
  );
};

export default MainComp;
